import { $t } from '@/i18n';
import { message } from 'ant-design-vue';
import Vue from 'vue';
const openVersionChooser = (candidates, baseUrl, failedUrls = new Set()) => new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const options = [
        {
            label: $t('k_b81aa179'),
            value: baseUrl,
            disabled: false,
        },
        ...candidates.map((x) => ({
            label: `ver=${x.runtimeVersion || ''} time=${x._mtime || ''}`,
            value: x.baseUrl,
            disabled: failedUrls.has(x.baseUrl),
        })),
    ];
    const lastFailedUrl = [...failedUrls].pop();
    const lastFailedItem = candidates.find(x => x.baseUrl === lastFailedUrl);
    const failedText = [
        $t('k_1c51e86f', { arg_0: location.href }),
        `baseUrl: ${lastFailedItem?.baseUrl || ''}`,
        `status: ${lastFailedItem?.status || ''}`,
        `runtimeVersion: ${lastFailedItem?.runtimeVersion || ''}`,
        $t('k_8d2a847', { arg_0: new Date().toLocaleString() }),
    ];
    // 使用 Vue2 + TSX 渲染 tdesign 选择弹窗
    // 依赖全局已注册的 tdesign 组件（项目已全局引入）
    // eslint-disable-next-line no-new
    new Vue({
        el: container,
        data() {
            return {
                visible: true,
                selected: options.find(opt => !opt.disabled)?.value || options[0]?.value,
                options,
            };
        },
        methods: {
            handleClose() {
                this.visible = false;
                this.$nextTick(() => {
                    try {
                        this.$destroy();
                    }
                    catch (_) {
                        /* ignore */
                    }
                    container.remove();
                    resolve(null);
                });
            },
            handleConfirm() {
                const val = this.selected;
                this.visible = false;
                this.$nextTick(() => {
                    try {
                        this.$destroy();
                    }
                    catch (_) {
                        /* ignore */
                    }
                    container.remove();
                    resolve(val);
                });
            },
            handleChange(val) {
                this.selected = val;
            },
            async handleCopy() {
                try {
                    if (navigator?.clipboard?.writeText) {
                        await navigator.clipboard.writeText(failedText.join('\n'));
                        message.success($t('k_8014ef31'));
                    }
                }
                catch (_) {
                    /* ignore */
                }
            },
        },
        render() {
            return (<t-dialog visible={this.visible} header={$t('k_d08ece71')} onClose={this.handleClose} onConfirm={this.handleConfirm}>
          <div>
            <h4>{$t('k_49d920f9')}</h4>
            <div class="relative">
              <t-tooltip content={$t('k_7bcb1437')} class="top-4px right-4px" style="position: absolute;">
                <t-button size="small" variant="text" onClick={this.handleCopy}>
                  <t-icon name="copy"/>
                </t-button>
              </t-tooltip>
              <t-alert theme="error" style="margin-bottom: 12px;" icon={() => (<></>)}>
                {failedText?.map((line, idx) => (<div key={idx}>{line}</div>))}
              </t-alert>
            </div>
          </div>
          <div>
            <t-select value={this.selected} onChange={this.handleChange} style="width:100%">
              {this.options.map((opt) => (<t-option value={opt.value} label={opt.label} disabled={opt.disabled}>
                  <div class="flex items-center justify-between">
                      <span>{opt.label}</span>
                    {opt.disabled && opt.value !== baseUrl && (<t-tag theme="danger" variant="light" size="small" style="margin-left: 12px;">{$t('k_88d1ef68')}</t-tag>)}
                  </div>
                </t-option>))}
            </t-select>
            <div style="margin-top:8px;color:var(--td-text-color-secondary)">
              {$t('k_3c12d276')}
            </div>
          </div>
        </t-dialog>);
        },
    });
});
export default openVersionChooser;
